/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistake_3Inputs */

const en_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not researching market rates beforehand`)
};

const de_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktsätze nicht vorher recherchieren`)
};

const fr_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne pas rechercher les taux du marché au préalable`)
};

const es_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No investigar las tarifas del mercado de antemano`)
};

const it_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non informarsi sui valori di mercato in anticipo`)
};

const nl_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet vooraf markttarieven onderzoeken`)
};

const pl_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak wcześniejszego sprawdzenia stawek rynkowych`)
};

const fi_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markkinahintojen tutkimatta jättäminen etukäteen`)
};

const da_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke at undersøge markedspriser på forhånd`)
};

const sv_salary_negotiate_mistake_3 = /** @type {(inputs: Salary_Negotiate_Mistake_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att inte undersöka marknadspriser i förväg`)
};

/**
* | output |
* | --- |
* | "Not researching market rates beforehand" |
*
* @param {Salary_Negotiate_Mistake_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistake_3 = /** @type {((inputs?: Salary_Negotiate_Mistake_3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistake_3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistake_3(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistake_3(inputs)
	if (locale === "es") return es_salary_negotiate_mistake_3(inputs)
	if (locale === "it") return it_salary_negotiate_mistake_3(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistake_3(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistake_3(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistake_3(inputs)
	if (locale === "da") return da_salary_negotiate_mistake_3(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistake_3(inputs)
	return en_salary_negotiate_mistake_3(inputs)
});